import {
  BuildFilled,
  GlobalOutlined,
  HeartOutlined,
  SettingOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MdOutlineAssistant } from "react-icons/md";
import { LuUsers } from "react-icons/lu";
import { LucideSquareFunction } from "lucide-react";
import { BsRobot } from "react-icons/bs";

export const agentPageSideMenuItems = [
  {
    key: "1",
    icon: <BsRobot className="me-2" />,
    label: "My Agents",
  },
  {
    key: "2",
    icon: <GlobalOutlined className="me-2" />,
    label: "Public Agents",
  },
  // {
  //     key: '3',
  //     icon: <HeartOutlined className="me-2" />,
  //     label: 'Favorite Agents',
  // },
  {
    key: "4",
    icon: <BuildFilled className="me-2" />,
    label: "Organizational Agents",
  },
  {
    key: "5",
    icon: <LucideSquareFunction style={{width:"19px"}} className="me-2" />,
    label: "Create Functions",
  },
  //    {
  //         key: '5',
  //         icon : <BuildFilled className="me-2" />,
  //         label: 'My Functions',
  //     },
  //     {
  //         key: '6',
  //         icon : <BuildFilled className="me-2" />,
  //         label: 'All Functions',
  //     },
  {
    key: "7",
    icon: <LuUsers className="me-2" />,
    label: "User Agents",
  },
];
